var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconheadersoundOff = function SvgIconheadersoundOff(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "25px",
    viewBox: "0 0 27 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Dashboard/SoundOff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dashboard/SoundOff",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speaker",
    transform: "translate(1, 0.5)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75,6.54583333 L5.9641946,6.54583333 C6.09170583,6.54583333 6.21439932,6.49711674 6.30718016,6.40964771 L12.1570144,0.894723608 C12.3579436,0.705297912 12.6743887,0.714623292 12.8638144,0.915552426 C12.9512834,1.00833327 13,1.13102675 13,1.25853799 L13,22.741462 C13,23.0176044 12.7761424,23.241462 12.5,23.241462 C12.3724888,23.241462 12.2497953,23.1927454 12.1570144,23.1052764 L6.30718016,17.5903523 C6.21439932,17.5028833 6.09170583,17.4541667 5.9641946,17.4541667 L0.75,17.4541667 C0.473857625,17.4541667 0.25,17.230309 0.25,16.9541667 L0.25,7.04583333 C0.25,6.76969096 0.473857625,6.54583333 0.75,6.54583333 Z",
    id: "Path-20",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.5, 9.1212)",
    fill: "#D8D8D8",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.55111512e-16,-2.22044605e-16 L7.15933489,6.75760751 M-5.55111512e-16,6.75760751 L7.15933489,-1.29674049e-13",
    id: "Combined-Shape",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconheadersoundOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.header.sound_off.e6009cffe7d0fd47d14f3c1881872e3e.svg";